import request from "@/utils/request.js";

// 获取微信公众号config信息 参数url
export function getWxConfig(data) {
    return request({
        url: "/api/wjr_jssdk_config",
        method: "post",
        data,
    });
}

// 获取企业微信config信息 参数url
export function getWxWorkConfig(data) {
    return request({
        url: "/api/wxwork/getConfig",
        method: "post",
        data,
    });
}

// 企业微信OAuth登录 根据code 获取内部员工的 userid
export function wxWorkLogin(data) {
    return request({
        url: "/api/wx/emp/bycode/" + data.code,
        method: "get",
    });
}

// 微信公众号OAuth登录 根据code 获取用户信息
export function wxLogin(data) {
    return request({
        url: "/api/wjr_callback",
        method: "get",
        params: data
    });
}
